const IntegracionesTable = ({ statusInfo, columnNames, selected }) => {
    return (
        <table>
            <thead>
                <tr>
                    {columnNames.map((col) => (
                        <th key={col?.key}>{col?.name}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {statusInfo.map((status) => (
                    <tr
                        key={status.id_crm}
                        id={`row-${status.name_crm}`}
                        style={{
                            backgroundColor:
                                selected?.label === status.name_crm ? '#bfdbc8ff' : '',
                        }}
                    >
                        {columnNames.map((col) => (
                            <td key={col?.key}>
                                {col?.render ? col.render(status[col?.key]) : status[col?.key]}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default IntegracionesTable;
